import React, { useEffect } from "react";
import "./ProjectsCard.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaReact, FaElementor } from "react-icons/fa";
import { SiTailwindcss, SiWordpress } from "react-icons/si";
import { SiFirebase } from "react-icons/si";
import { SiNodedotjs } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiBootstrap } from "react-icons/si";
import { SiMongodb } from "react-icons/si";
import { SiCss3 } from "react-icons/si";
import { SiHtml5 } from "react-icons/si";
import { SiJavascript } from "react-icons/si";
import { SiMaterialui } from "react-icons/si";

const ProjectsCard = ({ project }) => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      offset: 30,
    });
  }, []);

  return (
    <div
      data-aos="zoom-in"
      className={`relative transition-all form-text duration-400 card overflow-hidden`}
    >
      <div className={`bg-[#07101f] opacity-100 w-full h-full popup-info`}>
        <div className=" h-full flex justify-center items-center">
          <div className="space-y-8">
            <h4 className="text-2xl text-center font-semibold text-[#04BF00]">
              {project.name}
            </h4>
            {project?.tech && (
              <div className="flex flex-wrap justify-center gap-x-2 gap-y-3 px-5">
                {project?.tech.includes("html") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiHtml5 className="text-[#04BF00]"></SiHtml5>
                    <span className="text-[11px]">HTML 5</span>
                  </div>
                )}

                {project?.tech.includes("react") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <FaReact className="text-[#04BF00]" />
                    <span className="text-[11px]">React JS</span>
                  </div>
                )}

                {project?.tech.includes("css") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiCss3 className="text-[#04BF00]"></SiCss3>
                    <span className="text-[11px]">CSS 3</span>
                  </div>
                )}

                {project?.tech.includes("tailwind") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiTailwindcss className="text-[#04BF00]" />
                    <span className="text-[11px]">Tailwind</span>
                  </div>
                )}

                {project?.tech.includes("materialUI") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2">
                    <SiMaterialui className="text-[#04BF00]" />
                    <span className="text-[11px]">Material UI</span>
                  </div>
                )}

                {project?.tech.includes("javascript") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiJavascript className="text-[#04BF00]" />
                    <span className="text-[11px]">JavaScript</span>
                  </div>
                )}

                {project?.tech.includes("firebase") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiFirebase className="text-[#04BF00]"></SiFirebase>
                    <span className="text-[11px]">Firebase</span>
                  </div>
                )}

                {project?.tech.includes("node") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiNodedotjs className="text-[#04BF00]"></SiNodedotjs>
                    <span className="text-[11px]">Node JS</span>
                  </div>
                )}

                {project?.tech.includes("express") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiExpress className="text-[#04BF00]"></SiExpress>
                    <span className="text-[11px]">Express JS</span>
                  </div>
                )}

                {project?.tech.includes("bootstrap") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiBootstrap className="text-[#04BF00]"></SiBootstrap>
                    <span className="text-[11px]">Bootstrap</span>
                  </div>
                )}

                {project?.tech.includes("mongo") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiMongodb className="text-[#04BF00]"></SiMongodb>
                    <span className="text-[11px]">MongoDB</span>
                  </div>
                )}

                {project?.tech.includes("wordpress") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <SiWordpress className="text-[#04BF00]"></SiWordpress>
                    <span className="text-[11px]">WordPress</span>
                  </div>
                )}

                {project?.tech.includes("elementor") && (
                  <div className="flex justify-center items-center space-x-2 bg-[#0e223f] px-2 py-2 ">
                    <FaElementor className="text-[#04BF00]"></FaElementor>
                    <span className="text-[11px]">Elementor</span>
                  </div>
                )}
              </div>
            )}

            <div className="space-x-2 flex justify-center">
              {project.live && (
                <a
                  className="text-sm px-3 py-2 font-semibold bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                  href={project.live}
                  rel={"noreferrer"}
                  target={"_blank"}
                >
                  <i className="fa-solid fa-display mr-2 "></i>
                  <span>Demo</span>
                </a>
              )}
              {project.client && (
                <a
                  className="text-sm px-4 py-2 font-semibold flex items-center bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                  href={project.client}
                  rel={"noreferrer"}
                  target={"_blank"}
                >
                  <i className="fa-brands fa-github mr-2 text-[18px]"></i>
                  <span>Front-end</span>
                </a>
              )}
              {project.server && (
                <a
                  className="text-sm px-4 py-2 font-semibold flex items-center bg-white hover:bg-[#04BF00] text-gray-900 hover:text-white"
                  href={project.server}
                  rel={"noreferrer"}
                  target={"_blank"}
                >
                  <i className="fa-brands fa-github mr-2 text-[18px]"></i>
                  <span>Server</span>
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
      <img className="card-img" src={project.img} alt="" />
    </div>
  );
};

export default ProjectsCard;
